// parcel watch index.js --public-url ./

import "core-js/stable";
import "regenerator-runtime/runtime";

import ReactDOM from 'react-dom/client';
import React from 'react';
import MainRouter from './components/main-router';

// Configure Axios
import axios from 'axios';
axios.defaults.baseURL          = process.env.REACT_APP_API_ENDPOINT;
axios.defaults.withCredentials  = true;
axios.defaults.withXSRFToken    = true;
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common['Accept'] = 'application/json';

// Log Requests
// axios.interceptors.request.use(request => {
//     console.log('Starting Request', JSON.stringify(request, null, 2))
//     return request
// });
  
// Log Responses
// axios.interceptors.response.use(response => {
//     console.log('Response:', JSON.stringify(response, null, 2))
//     return response
// });

const root = ReactDOM.createRoot(document.getElementById("app"));
root.render(<MainRouter />);